module.exports = __webpack_public_path__ + "img/pending-payment.9792ae16.svg";